import { Component, ViewEncapsulation } from '@angular/core';
import { Meta, Title } from '@angular/platform-browser';
import {
  ScrollToConfigOptions,
  ScrollToService,
} from '@nicky-lenaers/ngx-scroll-to';
import { NgbCarouselConfig } from '@ng-bootstrap/ng-bootstrap';

@Component({
  selector: 'app-resident-engagement-page',
  templateUrl: './resident-engagement-page.component.html',
  styleUrls: ['./resident-engagement-page.component.scss'],
  encapsulation: ViewEncapsulation.None,
})
export class ResidentEngagementPageComponent {
  constructor(
    config: NgbCarouselConfig,
    private title: Title,
    private meta: Meta,
    private scrollToService: ScrollToService
  ) {
    config.interval = 10000;
    config.wrap = false;
    config.keyboard = false;
    config.pauseOnHover = false;

    this.meta.addTag({
      name: 'description',
      content:
        'Easy event calendar management for senior living — with smart activity planning, digital and print newsletters, digital signage, and family communications.',
    });
    this.title.setTitle('TSOLife | Resident Engagement for Assisted Living');
  }

  triggerScrollTo(target: string) {
    const config: ScrollToConfigOptions = {
      target,
    };
    this.scrollToService.scrollTo(config);
  }
}
